import { useEffect, useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { api, errMessage } from "@/lib/api";
import { PageTitle, Loading, ErrorBox, Empty } from "@/components/common";
import { Take5Card, InspectionCard } from "@/components/Cards";

const useActivities = (archived) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const load = () => {
    setError("");
    api.get("/activities", { params: { archived } }).then((r) => setData(r.data)).catch((e) => setError(errMessage(e)));
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, []);
  return { data, error, load };
};

const Current = () => {
  const { data, error, load } = useActivities(false);
  if (error) return <ErrorBox message={error} onRetry={load} />;
  if (!data) return <Loading />;
  return (
    <div className="space-y-8">
      <div>
        <h2 className="mb-3 font-heading text-lg font-bold uppercase">Take 5 ({data.take5s.length})</h2>
        {!data.take5s.length && <Empty testId="activities-take5-empty">Aucun Take 5 en cours. Les Take 5 sont archivés 24 h après leur fin prévue.</Empty>}
        <div className="grid gap-3 md:grid-cols-2" data-testid="activities-take5-list">{data.take5s.map((t) => <Take5Card key={t.id} t={t} />)}</div>
      </div>
      <div>
        <h2 className="mb-3 font-heading text-lg font-bold uppercase">Inspections ({data.inspections.length})</h2>
        {!data.inspections.length && <Empty testId="activities-inspections-empty">Aucune inspection.</Empty>}
        <div className="grid gap-3 md:grid-cols-2" data-testid="activities-inspections-list">{data.inspections.map((i) => <InspectionCard key={i.id} i={i} />)}</div>
      </div>
    </div>
  );
};

const Archived = () => {
  const { data, error, load } = useActivities(true);
  if (error) return <ErrorBox message={error} onRetry={load} />;
  if (!data) return <Loading />;
  return (
    <div>
      {!data.take5s.length && <Empty testId="activities-archived-empty">Aucun Take 5 archivé.</Empty>}
      <div className="grid gap-3 md:grid-cols-2" data-testid="activities-archived-list">{data.take5s.map((t) => <Take5Card key={t.id} t={t} />)}</div>
    </div>
  );
};

export default function Activities() {
  return (
    <div>
      <PageTitle kicker="Historique" title="Mes activités" testId="activities-title" />
      <Tabs defaultValue="current">
        <TabsList className="mb-6 h-12">
          <TabsTrigger value="current" data-testid="activities-tab-current" className="h-10 px-5 font-semibold">En cours</TabsTrigger>
          <TabsTrigger value="archived" data-testid="activities-tab-archived" className="h-10 px-5 font-semibold">Archivés</TabsTrigger>
        </TabsList>
        <TabsContent value="current"><Current /></TabsContent>
        <TabsContent value="archived"><Archived /></TabsContent>
      </Tabs>
    </div>
  );
}
